export default 'b2c-signup'
